import { Box as _Box } from '@material-ui/core';
import _Carousel from 'react-material-ui-carousel';
import _PerfectScrollbar from 'react-perfect-scrollbar';
import { Hidden as _Hidden} from '@material-ui/core';
import _DefaultLayout from './layouts/Default';
import { ErrorMessage as _ErrorMessage} from 'formik';

export const Box = _Box as React.FC<any>;
export const Carousel = _Carousel as React.FC<any>;
export const PerfectScrollbar = _PerfectScrollbar as unknown as React.FC<any>;
export const Hidden = _Hidden as React.FC<any>;
export const DefaultLayout = _DefaultLayout as React.FC<any>;
export const ErrorMessage = _ErrorMessage as React.FC<any>;
